{
    "extends": [
        "bpmnlint:recommended",
        "plugin:camunda-compat/camunda-platform-7-24"
    ]
}
